<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="card" color="primary">
          <v-card-title class="font-weight-bold justify-center">Inventario de municiones y cargadores</v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="end" align="center">
                <v-col cols="3">
                  <registrar-movimiento-dialog-component></registrar-movimiento-dialog-component>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="buscaMunicion"
                    rounded
                    filled
                    dense
                    hide-details
                    background-color="primary"
                    color="secondary"
                    label="Buscar por calibre"
                    append-icon="mdi-magnify"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    class="primary"
                    :headers="headers"
                    :items="municiones"
                    :search="buscaMunicion"
                    hide-default-footer
                    calculate-widths
                  >
                    <template v-slot:[`item.opciones`]="{ item }">
                      <v-btn rounded small color="secondary" class="mx-2" @click="openMovimientosDialog(item)"
                        >Ver movimientos</v-btn
                      >
                      <v-btn rounded small color="secondary" class="mx-2" @click="openListaCargadoresDialog(item)">
                        Ver lista de cargadores</v-btn
                      >
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <historial-movimientos-dialog-component
      :active="historialMovimientosDialog"
      :calibre="selectedCalibre"
      @close="historialMovimientosDialog = false"
    ></historial-movimientos-dialog-component>
    <lista-cargadores-dialog-component
      :active="listaCargadoresDialog"
      @close="listaCargadoresDialog = false"
    ></lista-cargadores-dialog-component>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import HistorialMovimientosDialogComponent from '../../components/armeria/HistorialMovimientosDialogComponent.vue'
import ListaCargadoresDialogComponent from '../../components/armeria/ListaCargadoresDialogComponent.vue'
import RegistrarMovimientoDialogComponent from '../../components/armeria/RegistrarMovimientoDialogComponent.vue'

export default {
  components: {
    RegistrarMovimientoDialogComponent,
    HistorialMovimientosDialogComponent,
    ListaCargadoresDialogComponent,
  },

  data() {
    return {
      headers: [
        { text: 'Calibre', value: 'calibre', width: '10%' },
        { text: 'Opciones', value: 'opciones', align: 'center', width: '10%' },
      ],

      buscaMunicion: '',

      historialMovimientosDialog: false,
      listaCargadoresDialog: false,

      movimientosCargador: [],
      movimientosMunicion: [],

      selectedCalibre: null,
    }
  },

  computed: {
    ...mapGetters('calibre', {
      calibres: 'getCalibres',
    }),

    ...mapGetters('movimientoMunicion', {
      movimientoMunicion: 'getMovimientoMunicion',
    }),

    municiones: function () {
      var municiones = []
      this.calibres.forEach((calibre) => {
        municiones.push({
          idCalibre: calibre.id,
          calibre: calibre.title,
          stock_municiones: this.getStockMunicionesByCalibre(calibre.id),
          stock_cargadores: 0,
        })
      })
      return municiones
    },
  },

  methods: {
    ...mapActions('movimientoMunicion', ['fetchMovimientoMunicion', 'fetchMovimientoMunicionDisponibles']),
    ...mapActions('movimientoCargador', ['fetchMovimientoCargador', 'fetchMovimientoCargadorDisponibles']),
    ...mapActions('cargadores', ['fetchCargadores']),

    async openMovimientosDialog(calibre) {
      this.selectedCalibre = calibre
      await this.fetchMovimientoCargador(calibre.idCalibre)
      await this.fetchMovimientoCargadorDisponibles(calibre.idCalibre)
      await this.fetchMovimientoMunicion()
      await this.fetchMovimientoMunicionDisponibles(calibre.idCalibre)

      this.historialMovimientosDialog = true
    },

    async openListaCargadoresDialog(calibre) {
      this.selectedCalibre = calibre
      await this.fetchCargadores(calibre.idCalibre)

      this.listaCargadoresDialog = true
    },

    getStockMunicionesByCalibre(id_calibre) {
      var stock = 0

      var filteredMuniciones = this.movimientoMunicion.filter((movimiento) => {
        return movimiento.fk_idCatCalibre == id_calibre
      })

      filteredMuniciones.forEach((movimiento) => {
        if (movimiento.fk_idcatTipoMovimiento == 1) {
          stock += movimiento.cantidad
        } else {
          stock -= movimiento.cantidad
        }
      })

      return stock
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para InventarioMuniciones */
.card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out;
}

/* Títulos */
.v-card-title {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
}

/* Tabla */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-table-header {
  background: linear-gradient(180deg, rgba(108, 92, 231, 0.15) 0%, rgba(108, 92, 231, 0.08) 100%) !important;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 600 !important;
  border-bottom: 2px solid rgba(108, 92, 231, 0.3) !important;
  padding: 16px !important;
}

::v-deep .v-data-table tbody tr {
  transition: all 0.3s ease;
  cursor: pointer;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(108, 92, 231, 0.1) !important;
  transform: scale(1.005);
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(108, 92, 231, 0.1) !important;
  padding: 16px !important;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px;
  text-transform: none;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

::v-deep .v-btn:hover::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 92, 231, 0.3);
}

::v-deep .v-btn.secondary {
  background: linear-gradient(135deg, #6c5ce7 0%, #a29bfe 100%) !important;
  color: #ffffff !important;
}

::v-deep .v-btn:disabled {
  opacity: 0.5 !important;
}

/* Input de búsqueda */
::v-deep .v-text-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: 1px solid rgba(108, 92, 231, 0.2);
  transition: all 0.3s ease;
}

::v-deep .v-input--is-focused .v-input__control {
  border-color: #6c5ce7 !important;
  box-shadow: none !important;
}

::v-deep .v-text-field__slot input {
  color: #e0e0e0 !important;
}

::v-deep .v-label {
  color: #b0b0b0 !important;
}

::v-deep .v-input--is-focused .v-label {
  color: #6c5ce7 !important;
}

/* Iconos */
::v-deep .v-icon {
  color: #e0e0e0;
  transition: all 0.3s ease;
}

::v-deep .v-btn .v-icon {
  color: #ffffff !important;
}

::v-deep .v-input__icon .v-icon {
  color: rgba(108, 92, 231, 0.7) !important;
}

::v-deep .v-input--is-focused .v-input__icon .v-icon {
  color: #6c5ce7 !important;
}

/* Data footer */
::v-deep .v-data-footer {
  background: rgba(18, 18, 18, 0.5) !important;
  border-top: 1px solid rgba(108, 92, 231, 0.2) !important;
}

::v-deep .v-data-footer__select .v-select {
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__pagination {
  color: #e0e0e0 !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  color: #e0e0e0 !important;
  padding: 8px 12px;
  font-size: 0.875rem;
  font-weight: 500;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}

/* Animación */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
